import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Divider,
} from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';
import ChangePasswordDialog from '../components/ChangePasswordDialog';

export default function Settings() {
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Settings
      </Typography>
      
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Security
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <LockIcon color="action" />
            <Box sx={{ flex: 1 }}>
              <Typography variant="subtitle1">Password</Typography>
              <Typography variant="body2" color="text.secondary">
                Change your account password
              </Typography>
            </Box>
            <Button
              variant="outlined"
              onClick={() => setChangePasswordOpen(true)}
            >
              Change Password
            </Button>
          </Box>
        </CardContent>
      </Card>

      <ChangePasswordDialog
        open={changePasswordOpen}
        onClose={() => setChangePasswordOpen(false)}
      />
    </Box>
  );
} 